/**
* Testimonial Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider component.
*/

( function( app ) {
  const COMPONENT = {
    className: 'testimonial-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonials__slider' ).slick( {
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $( '.testimonials__prev' ),
        nextArrow: $( '.testimonials__next' ),
      } );
    },
    finalize: function() {

    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider', COMPONENT );
} )( app );

